/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as Sentry from "@sentry/nextjs";

// import posthog from "posthog-js";

/**
 * @description Initialize Sentry (only if DSN is configured in the browser environment)
 * Note: SENTRY_AUTH_TOKEN is server-only; Sentry on the client uses the hardcoded DSN.
 */
const sentryDsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const sentryEnabled = process.env.NEXT_PUBLIC_SENTRY_ENABLED === "true" && Boolean(sentryDsn);

if (sentryEnabled && sentryDsn) {
  Sentry.init({
    enabled: process.env.NODE_ENV !== "development",
    dsn: sentryDsn,

    sendDefaultPii: true,

    // @ts-ignore
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    tracesSampleRate: 1,
    enableLogs: true,

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    debug: false,
  });
}

export const onRouterTransitionStart = (
  ...args: Parameters<typeof Sentry.captureRouterTransitionStart>
) => {
  if (!sentryEnabled) return;
  return Sentry.captureRouterTransitionStart(...args);
};
